import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@vendure/admin-ui/core';
import { SellerBrandsEditorComponent } from './seller-brands-editor.component';

@NgModule({
    declarations: [SellerBrandsEditorComponent],
    exports: [SellerBrandsEditorComponent],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SellerBrandsSharedModule {}
